var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalFullScreen",
    { attrs: { size: "md" }, on: { close: _vm.closeModal } },
    [
      [
        _c("ModalContent", { staticClass: "relative" }, [
          _c(
            "div",
            { staticClass: "bg-white z-100 rounded-md text-gray-400" },
            [
              _c(
                "div",
                {
                  staticClass: "flex-1 bg-white justify-between flex flex-col",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "md:flex justify-between py-4 items-center",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "text-gray-900 text-xl font-bold" },
                        [_vm._v(" Decline Reason ")]
                      ),
                      _c("span", { staticClass: "flex gap-2" }, [
                        _c(
                          "span",
                          { staticClass: "text-gray-400 text-md mt-1" },
                          [_vm._v("For Requested Hours")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "text-gray-900 text-xl font-bold flex-shrink-0",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.convertSecondsToReadable(_vm.time.hours)
                                ) +
                                " HRS "
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "cursor-pointer z-100",
                          on: { click: _vm.closeModal },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "mb-0.5",
                              attrs: {
                                width: "26",
                                height: "26",
                                viewBox: "0 0 13 12",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10.728 1.75737C8.38605 -0.584572 4.58465 -0.584572 2.24271 1.75737C-0.0992269 4.0993 -0.0992267 7.90071 2.24271 10.2426C4.58465 12.5846 8.38605 12.5846 10.728 10.2426C13.0699 7.90071 13.0699 4.0993 10.728 1.75737ZM7.75814 8.12133L6.48535 6.84853L5.21256 8.12133C4.97921 8.35467 4.59738 8.35467 4.36403 8.12133C4.13069 7.88798 4.13069 7.50614 4.36403 7.2728L5.63682 6.00001L4.36403 4.72721C4.13069 4.49387 4.13069 4.11203 4.36403 3.87869C4.59738 3.64534 4.97921 3.64534 5.21256 3.87869L6.48535 5.15148L7.75814 3.87869C7.99149 3.64534 8.37333 3.64534 8.60667 3.87869C8.84002 4.11203 8.84002 4.49387 8.60667 4.72721L7.33388 6.00001L8.60667 7.2728C8.84002 7.50614 8.84002 7.88798 8.60667 8.12133C8.37333 8.35467 7.99149 8.35467 7.75814 8.12133Z",
                                  fill: "#1A7BEE",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col h-40 space-y-4 p-3 overflow-y-auto overflow-auto scrollbar scrolling-touch",
                      attrs: { id: "messages" },
                    },
                    [
                      _c("div", { staticClass: "chat-message" }, [
                        _c("div", { staticClass: "flex items-end" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col space-y-2 text-md max-w-full mx-2 order-1 items-start",
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "px-4 py-2 rounded-lg inline-block rounded-tl-none bg-white border border-gray-300 text-gray-800",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.time.decline_reason) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }